import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles<{
  hasHideIcon: boolean
}>({
  heading({ spacing }) {
    return css`
      display: flex;
      flex-direction: column;
      //TODO refactor necessáro em px por conta do bug do line-height no hero
      gap: ${spacing.xs};
      margin-top: ${spacing.xs};
      margin-bottom: ${spacing.md};
    `
  },
  content() {
    return css`
      display: flex;
      flex-direction: column;
      //TODO refactor necessáro em px por conta do bug do line-height no hero
      gap: 36px;
    `
  },
  sectionTitle: ({ colors, spacing }, hasHideIcon) => {
    return css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: ${hasHideIcon ? 'space-between' : 'start'};
      hr {
        flex-grow: 1;
        border: none;
        border-bottom: 1px solid ${colors.neutral[100]};
        margin-left: ${spacing.xs};
      }
    `
  },

  sectionGridContent: ({ spacing }) => {
    return css`
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: stretch;
      row-gap: ${spacing.xxs};
      margin: calc(-1.5rem / 2);
      //TODO refactor necessáro em px por conta do bug do line-height no hero
      margin-top: 22px;
    `
  },

  sectionGridCol: ({ spacing, grid }) => css`
    flex: 0 0 100%;
    padding: ${spacing.xxs};
    max-width: 33.3%;

    @media (max-width: ${grid.breakpoint.lg}) {
      flex: 0 0 50%;
      max-width: 50%;
    }

    @media (max-width: ${grid.breakpoint.sm}) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  `,

  sectionFullGridCol: ({ spacing }) => css`
    flex: 0 0 100%;
    max-width: 100%;
    padding-inline: ${spacing.xxs};
  `,

  footer() {
    return css`
      display: flex;
      justify-content: end;
      //TODO refactor necessáro em px por conta do bug do line-height no hero
      margin-top: 12px;
    `
  },
})

export default useStyles
